import React from 'react'
import {Stack,Typography,Button} from '@mui/material'
import BodyPartImage from '../assets/icons/body-part.png';
import TargetImage from '../assets/icons/target.png';
import EquipmentImage from '../assets/icons/equipment.png';

const Details = ({exerciseDetail}) => {

   if(exerciseDetail.length===0){
    return <h1>loading...</h1>
   }

  const {bodyPart,gifUrl,name,target,equipment}=exerciseDetail;

  const extraDetails=[
    {
      icon:BodyPartImage,
      name:bodyPart
    },{
      icon:TargetImage,
      name:target
    },{
      icon:EquipmentImage,
      name:equipment
    }
  ]
  return (
    <Stack gap="60px" sx={{flexDirection:{lg:'row'},p:'20px',alignItems:'center'}}>
      <img src={gifUrl} alt={name} loading="lazy" className='detail-image' />
      <Stack>
        <Typography variant='h3'>
          {name}
        </Typography>
        <Typography variant='h6'>
          Exercise keeps you strong {name}{` `}
          is one of the best exercises to target your {target}. It will help you
          imporve your 
          mood and gain energy.
        </Typography>
        {extraDetails.map((item,index)=>
            (<Stack key={index} direction="row" gap="24px" alignItems="center">
              <Button sx={{background:'#fff2db',borderRadius:'50%',width:'100px',height:'100px'}}>
              <img src={item.icon} style={{widht:'50px',height:'50px'}}/>
              </Button>
              <Typography textTransform="capitalize" variant='h5'>{item.name}</Typography>
      </Stack>
      ))}
      </Stack>
    </Stack>
  )
}

export default Details